import { render, staticRenderFns } from "./widget-code-snippet.vue?vue&type=template&id=44e7cecd&scoped=true&lang=html"
import script from "./widget-code-snippet.vue?vue&type=script&lang=js"
export * from "./widget-code-snippet.vue?vue&type=script&lang=js"
import style0 from "./widget-code-snippet.vue?vue&type=style&index=0&id=44e7cecd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e7cecd",
  null
  
)

/* custom blocks */
import block0 from "./widget-code-snippet.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports